import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { checkDuplicateTranslationKeys, defaultNS, enLang, i18nNS } from './helpers';

export { defaultNS, enLang, i18nNS };

if (process.env.NODE_ENV === 'development') {
  checkDuplicateTranslationKeys(enLang);
}

i18n
  /** Tell i18n to detect browser's default language */
  .use(LanguageDetector)
  /** Tell i18n to use it with react */
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    returnNull: false,

    ns: [i18nNS.COMMON, i18nNS.SHARED, i18nNS.GLOSSARY, i18nNS.VALIDATION],
    defaultNS,

    resources: {
      en: enLang,
    },

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      formatSeparator: ',',
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
